<div class="network-vie">
  <div id="mynetwork" class="network-container"></div>
</div>
